import {ReactNode} from "react";
import './ModalScreen.css';

export const ModalScreen = ({children}: { children: ReactNode | ReactNode[] }) =>
  <div className="ModalScreen">
    {children}
  </div>;
